import { render } from "./RentalDelivery.vue?vue&type=template&id=f794b93a&scoped=true"
import script from "./RentalDelivery.vue?vue&type=script&lang=js"
export * from "./RentalDelivery.vue?vue&type=script&lang=js"

import "./RentalDelivery.vue?vue&type=style&index=0&id=f794b93a&scoped=true&lang=css"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f794b93a"]])

export default __exports__